import React from 'react'
import { Typography, Link } from '@material-ui/core'
import { TokenStorage } from "../../api/auth/TokenStorage"

const Copyright = () => {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://www.dopago.com/">
                Dopago ApS 
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
            {TokenStorage.getTokens() === null
                ? <></>
                : <>{' Har du spørgsmål eller feedback til Webportalen, kan du skrive til '} <Link color="inherit" href="mailto:service@dopago.com">service@dopago.com</Link></>
            }
        </Typography>
      )
}

export default Copyright
